<template>
  <div>
    <div class="ui-center p-3 column recuperar">
      <h1 class="ui-title f-32 titulo">Recuperar senha</h1>
      <div>
        <h4 class="ui-paragraph f-20 frase">
          Para continuarmos, escreva o seu e-mail.
        </h4>
        <input type="hidden" name="_token" :value="token" />
        <input type="hidden" name="_method" value="POST" />
        <div class="bloco-input">
          <input
            class="ui-input input"
            type="email"
            name="email"
            v-model="email"
            @keyup.enter.prevent="sendForm()"
          />
        </div>
        <button
          class="ui-button-yellow button"
          type="button"
          @click.prevent="sendForm()"
          :disabled="btnSubmit.disabled"
          v-html="btnSubmit.text"
        >
        </button>
      </div>
      <a href="/login" class="f-20">
        <h4 class="ui-paragraph f-20">Voltar</h4>
      </a>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["token"],
  data() {
    return {
      email: "",
      btnSubmit: {
        text: "Continuar",
        disabled: false
      }
    };
  },
  methods: {
    sendForm: function () {
      this.btnSubmit.text = "<div class='loader'></div>"
      this.btnSubmit.disabled = true
      axios.post("/enviar-recuperacao", { email: this.email }).then((res) => {
        this.$swal({
          title: res.data,
          text: 'Confira sua caixa de mensagens para localizar o link de alteração',
          type: "success",
          preConfirm: () => {
            window.location.href = "/login";
          },
        }).then((r) => {
          if (r.dismiss) {
            window.location.href = "/login";
          }
        });
      }).catch((e) => {
        this.$swal({
          title: e.response.data,
          type: "error",
          preConfirm: () => {
            window.location.href = "/recuperacao"
          },
        }).then((r) => {
          if (r.dismiss) {
            window.location.href = "/recuperacao"
          }
        });
      })
      .finally((f) => {
        this.btnSubmit.text = "Continuar"
        this.btnSubmit.disabled = false
      });
    },
  },
};
</script>
